import { MainColor } from '../../palette';

export const getDependencyGraphTheme = () => {
  return {
    nodes: {
      task: {
        default: {
          background: 'coolGrey10' satisfies MainColor as MainColor,
          border: 'coolGrey20' satisfies MainColor as MainColor,
          content: 'coolGrey80' satisfies MainColor as MainColor,
        },
        disabled: {
          border: 'coolGrey10' satisfies MainColor as MainColor,
          background: 'coolGrey5' satisfies MainColor as MainColor,
          content: 'coolGrey50' satisfies MainColor as MainColor,
        },
        clicked: 'coolGrey80' satisfies MainColor as MainColor,
        overdue: 'rose40' satisfies MainColor as MainColor,
      },
      resource: {
        default: {
          border: 'coolGrey30' satisfies MainColor as MainColor,
          background: 'coolGrey20' satisfies MainColor as MainColor,
          content: 'coolGrey60' satisfies MainColor as MainColor,
        },
        disabled: {
          border: 'coolGrey10' satisfies MainColor as MainColor,
          background: 'coolGrey5' satisfies MainColor as MainColor,
          content: 'coolGrey50' satisfies MainColor as MainColor,
        },
        clicked: 'coolGrey80' satisfies MainColor as MainColor,
      },
    },
  };
};

export type DependencyGraphTheme = ReturnType<typeof getDependencyGraphTheme>;
